<template>
  <div
    :data-card-id="card.id" data-card-type="r"
    class="card position-relative"
    :class="{ 'inactive': !isActive, 'card--tapped': isTapped }"
    @click="handleCardClick"
    @mouseenter="showHint = true"
    @mouseleave="showHint = false">
    <!-- Card removal button -->
    <div class="card__remove">
      <el-popover
        placement="bottom"
        width="200"
        trigger="click"
        v-model="popover_visible2">
        <p style="font-size: 15px;">Вы уверены?</p>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" style="color: #666; outline: none!important;" @click="popover_visible2 = false">Отмена</el-button>
          <el-button type="danger" size="mini" @click="handleRemove">Удалить</el-button>
        </div>
        <el-button class="card__remove-btn" slot="reference" size="medium" type="danger" icon="el-icon-delete" circle></el-button>
      </el-popover>
    </div>

    <!-- Card edit button at top left corner -->
    <div class="card__edit">
      <el-popover
        v-model="popover_visible"
        placement="bottom"
        width="240"
        trigger="click">
        <div class="d-flex mb-1">
          <span class="limit-text">Лимиты</span>
          <vs-switch class="ml-2" color="success" v-model="limit.is_limited"></vs-switch>
        </div>

        <template v-if="limit.is_limited">
          <div class="limit-edit-form">
            <div class="limit-edit-group">
              <span class="limit-edit-label">Дневной лимит</span>
              <el-input
                type="number"
                size="small"
                class="limit-edit-input"
                v-model="limit.week"
                placeholder="Сумма">
              </el-input>
            </div>

            <div class="limit-edit-group">
              <span class="limit-edit-label">Месячный лимит</span>
              <el-input
                type="number"
                size="small"
                class="limit-edit-input"
                v-model="limit.month"
                placeholder="Сумма">
              </el-input>
            </div>

            <div class="limit-edit-group">
              <span class="limit-edit-label">Мин. сумма</span>
              <el-input
                type="number"
                size="small"
                class="limit-edit-input"
                v-model="limit.amount_min"
                placeholder="Сумма">
              </el-input>
            </div>

            <div class="limit-edit-group">
              <span class="limit-edit-label">Макс. сумма</span>
              <el-input
                type="number"
                size="small"
                class="limit-edit-input"
                v-model="limit.amount_max"
                placeholder="Сумма">
              </el-input>
            </div>

            <div class="limit-edit-group">
              <span class="limit-edit-label">Макс. транзакций</span>
              <el-input
                type="number"
                size="small"
                class="limit-edit-input"
                v-model="limit.transactions_max"
                placeholder="Количество">
              </el-input>
            </div>
          </div>
        </template>

        <div class="mt-3" style="text-align: right; margin: 0">
          <el-button size="mini" class="mr-2 pr-1" type="text" style="color: #555; outline: none!important;" @click="popover_visible = false">Отмена</el-button>
          <el-button type="success" size="mini" @click="handleSubmit">Сохранить</el-button>
        </div>

        <el-button slot="reference" class="card__edit-btn" size="mini" icon="el-icon-edit" circle @click.stop></el-button>
      </el-popover>
    </div>

    <!-- Card content -->
    <div class="card__content">
      <div class="card__header">
        <div class="card__brand-logo">Банк</div>
        <div class="card__status">
          <div class="card__status-indicator" :class="isActive ? 'active' : 'inactive'"></div>
          <div class="card__status-text">{{ isActive ? 'Активна' : 'Неактивна' }}</div>
        </div>
      </div>

      <div class="card__chip">
        <svg width="45" height="35" viewBox="0 0 45 35" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="45" height="35" rx="6" fill="url(#chipGradient)"/>
          <rect x="8" y="8" width="10" height="18" fill="rgba(0,0,0,0.1)" />
          <rect x="27" y="8" width="10" height="18" fill="rgba(0,0,0,0.1)" />
          <rect x="4" y="17" width="37" height="1" fill="rgba(0,0,0,0.1)" />
          <defs>
            <linearGradient id="chipGradient" x1="0" y1="0" x2="45" y2="35" gradientUnits="userSpaceOnUse">
              <stop stop-color="#FFFCB1"/>
              <stop offset="1" stop-color="#B4A365"/>
            </linearGradient>
          </defs>
        </svg>
      </div>

      <div class="card__number" :title="card.number">{{ formatCardNumber(card.number) }}</div>

      <div class="card__limits">
        <div v-if="card.is_limited" class="card__limit-info">
          <div class="card__limit-row">
            <span class="card__limit-label">День:</span>
            <span class="card__limit-value">{{ formatCurrency(card.limit_week) }}</span>
          </div>
          <div class="card__limit-row">
            <span class="card__limit-label">Месяц:</span>
            <span class="card__limit-value">{{ formatCurrency(card.limit_month) }}</span>
          </div>
        </div>
        <div v-else class="card__limit-info card__limit-info--unlimited">
          <div class="card__limit-value">Без лимита</div>
        </div>
      </div>

      <!-- Tap hint shown on hover or single tap -->
      <transition name="fade">
        <div v-if="showHint || isTapped" class="card__tap-hint">
          <span>Нажмите дважды, чтобы {{ isActive ? 'деактивировать' : 'активировать' }}</span>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'RCreditCard',
  data() {
    return {
      doneFetching: false,
      isActive: this.card.is_active,
      color: '#4361EE',
      popover_visible: false,
      popover_visible2: false,
      lastTap: 0, // For mobile double tap detection
      isTapped: false, // To track single tap state
      showHint: false, // For hover state on desktop
      tapTimeout: null, // For handling single tap timeout
      limit: {
        is_limited: this.card.is_limited,
        number: this.card.limit,
        week: this.card.limit_week,
        month: this.card.limit_month,
        amount_min: this.card.amount_min,
        amount_max: this.card.amount_max,
        transactions_max: this.card.transactions_max
      }
    }
  },
  props: {
    card: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    async handleRemove() {
      this.popover_visible2 = false;
      try {
        await axios.delete('dashboard/r-cards/' + this.card.id)
        this.$notify({
          title: 'Успешно',
          message: 'Карта успешно удалена',
          type: 'success'
        });
        this.$emit('card_removed')
      } catch (error) {
        console.log(error);
      }
    },
    async handleSubmit() {
      const response = await axios.put('dashboard/r-cards/' + this.card.id, {
        number: this.card.number,
        limit: this.limit.number,
        limit_week: this.limit.week,
        limit_month: this.limit.month,
        is_limited: this.limit.is_limited,
        amount_min: this.limit.amount_min,
        amount_max: this.limit.amount_max,
        transactions_max: this.limit.transactions_max,
        is_active: this.isActive
      })
      this.limit.is_limited = this.limit.is_limited
      this.popover_visible = false
      if (response.data.status === true) {
        this.$notify({
          title: 'Успешно',
          message: 'Изменения сохранены',
          type: 'success'
        });
      }
      this.$emit('limit_edited')
    },
    handleCardClick(event) {
      // Skip if click is on buttons or popover
      if (event.target.closest('.card__edit') || event.target.closest('.card__remove')) {
        return;
      }

      // Handle single tap
      this.isTapped = true;
      clearTimeout(this.tapTimeout);

      // Reset tapped state after 1.5 seconds
      this.tapTimeout = setTimeout(() => {
        this.isTapped = false;
      }, 1500);

      const currentTime = new Date().getTime();
      const tapInterval = currentTime - this.lastTap;

      // Detect double tap/click (300ms is a common threshold)
      if (tapInterval < 300 && tapInterval > 0) {
        this.toggleActiveStatus();
        event.preventDefault(); // Prevent zoom on mobile
      }

      this.lastTap = currentTime;
    },
    async toggleActiveStatus() {
      // Toggle active status on double click
      this.isActive = !this.isActive;

      try {
        await axios.put('dashboard/r-cards/' + this.card.id, {
          is_active: this.isActive
        });

        this.$notify({
          title: 'Статус изменен',
          message: this.isActive ? 'Карта активирована' : 'Карта деактивирована',
          type: 'success'
        });
      } catch (error) {
        console.error(error);
        // Revert status on error
        this.isActive = !this.isActive;

        this.$notify({
          title: 'Ошибка',
          message: 'Не удалось изменить статус карты',
          type: 'error'
        });
      }
    },
    formatCardNumber(number) {
      if (!number) return '';
      // Format like XXXX XXXX XXXX XXXX
      return number.toString().replace(/\s/g, '').replace(/(.{4})/g, '$1 ').trim();
    },
    formatCurrency(amount) {
      if (!amount) return '0 UZS';
      return new Intl.NumberFormat('uz-UZ', {
        style: 'decimal',
        currency: 'UZS',
      }).format(amount) + ' UZS';
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&display=swap');

.card {
  width: 330px;
  height: 210px;
  position: relative;
  overflow: visible;
  border-radius: 20px;
  font-family: 'Roboto', sans-serif;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #4361EE, #3A0CA3);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  cursor: pointer; /* Show pointer cursor to indicate interactivity */
  -webkit-tap-highlight-color: transparent; /* Remove tap highlight on mobile */
  user-select: none; /* Prevent text selection during double-tap */

  &:active {
    transform: scale(0.98);
  }

  &.inactive {
    background: linear-gradient(135deg, #8B8B8B, #616161);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  /* Slightly highlight card when tapped once */
  &--tapped {
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5), 0 10px 20px rgba(0, 0, 0, 0.2);
  }

  &__content {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 10;
    box-sizing: border-box;
  }

  &__remove {
    position: absolute;
    top: -10px;
    right: -10px;
    z-index: 30;
  }

  &__edit {
    position: absolute;
    top: -10px;
    left: -10px;
    z-index: 30;
  }

  &__remove-btn {
    background-color: #ff4d4f;
    color: white;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease;

    &:hover {
      background-color: #ff7875;
      transform: scale(1.05);
    }
  }

  &__edit-btn {
    background: #ffffff;
    color: #4361EE;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transition: all 0.2s ease;

    &:hover {
      background: #f5f5f5;
      transform: scale(1.05);
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  &__brand-logo {
    font-size: 24px;
    font-weight: 700;
    color: white;
    letter-spacing: 1px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  &__status {
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 12px;
    padding: 4px 8px;
  }

  &__status-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 6px;

    &.active {
      background-color: #52c41a;
      box-shadow: 0 0 6px rgba(82, 196, 26, 0.6);
    }

    &.inactive {
      background-color: #ff4d4f;
      box-shadow: 0 0 6px rgba(255, 77, 79, 0.6);
    }
  }

  &__status-text {
    font-size: 12px;
    color: white;
    font-weight: 500;
  }

  &__chip {
    margin-top: 8px;
    margin-bottom: 16px;
  }

  &__number {
    font-family: 'Space Mono', monospace;
    font-size: 20px;
    color: white;
    letter-spacing: 2px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    margin-bottom: 6px;
  }

  &__limits {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: auto;
  }

  &__limit-info {
    color: white;

    &--unlimited {
      background: rgba(255, 255, 255, 0.15);
      padding: 6px 12px;
      border-radius: 20px;
      display: inline-block;

      .card__limit-value {
        font-weight: 500;
      }
    }
  }

  &__limit-row {
    display: flex;
    margin-bottom: 4px;
  }

  &__limit-label {
    font-size: 12px;
    margin-right: 6px;
    opacity: 0.8;
  }

  &__limit-value {
    font-size: 12px;
    font-weight: 500;
  }

  /* Tap hint shown on hover or single tap */
  &__tap-hint {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    font-size: 12px;
    padding: 8px 0;
    border-radius: 0 0 20px 20px;
  }
}

// Fade transition for the hint
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

// Limit edit popover styling
.limit {
  &-text {
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }

  &-edit {
    &-form {
      margin-top: 12px;
    }

    &-group {
      margin-bottom: 12px;
    }

    &-label {
      display: block;
      font-size: 12px;
      margin-bottom: 4px;
      color: #606266;
    }

    &-input {
      width: 100%;
    }
  }
}

// Mobile responsiveness
@media (max-width: 576px) {
  .card {
    width: 100%;
    max-width: 330px;
    margin: 0 auto;

    &__number {
      font-family: 'Space Mono', monospace;
      font-size: 18px;
      color: white;
      letter-spacing: 2px;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
      margin-bottom: 6px;
    }
  }
}
</style>
